import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "46.08",
  height: "46.08",
  stroke: "currentColor",
  "aria-hidden": "true",
  viewBox: "0 0 512 512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "none",
      "stroke-miterlimit": "10",
      "stroke-width": "32",
      d: "M248 64C146.39 64 64 146.39 64 248s82.39 184 184 184 184-82.39 184-184S349.61 64 248 64z"
    }, null, -1 /* HOISTED */),
    _createElementVNode("path", {
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "32",
      d: "M220 220h32v116"
    }, null, -1 /* HOISTED */),
    _createElementVNode("path", {
      fill: "none",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "32",
      d: "M208 340h88"
    }, null, -1 /* HOISTED */),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M248 130a26 26 0 1 0 26 26 26 26 0 0 0-26-26z"
    }, null, -1 /* HOISTED */)
  ])))
}
export default { render: render }